import {
  Avatar,
  Badge,
  Box,
  Divider,
  Flex,
  Text,
  Wrap,
  WrapItem,
} from '@chakra-ui/react';
import { IoCallOutline } from 'react-icons/io5';
import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import {
  getAllRooms,
  getThreads,
} from '../../redux/actions/conversationActions';

const names = [
  {
    id: 1,
    first_name: 'John',
    last_name: 'Doe',
    phone_number: '+1-648-360-1848',
    timestamp: '2023-01-01T12:06:39.187Z',
  },
  {
    id: 2,
    first_name: 'Jane',
    last_name: 'Smith',
    phone_number: '+1-293-892-9928',
    timestamp: '2023-01-04T04:51:17.932Z',
  },
  {
    id: 3,
    first_name: 'Alice',
    last_name: 'Johnson',
    phone_number: '+1-913-571-5293',
    timestamp: '2023-01-07T15:21:00.282Z',
  },
  {
    id: 4,
    first_name: 'Bob',
    last_name: 'Brown',
    phone_number: '+1-450-763-9196',
    timestamp: '2023-01-10T00:22:06.808Z',
  },
  {
    id: 5,
    first_name: 'Charlie',
    last_name: 'Davis',
    phone_number: '+1-489-442-7603',
    timestamp: '2023-01-13T18:26:18.905Z',
  },
  {
    id: 6,
    first_name: 'Diana',
    last_name: 'Evans',
    phone_number: '+1-482-886-7604',
    timestamp: '2023-01-16T01:59:22.535Z',
  },
  {
    id: 7,
    first_name: 'Evan',
    last_name: 'Wilson',
    phone_number: '+1-960-377-9061',
    timestamp: '2023-01-19T09:03:29.693Z',
  },
  {
    id: 8,
    first_name: 'Fiona',
    last_name: 'Garcia',
    phone_number: '+1-904-308-7122',
    timestamp: '2023-01-22T00:03:42.087Z',
  },
  {
    id: 9,
    first_name: 'George',
    last_name: 'Harris',
    phone_number: '+1-996-177-4114',
    timestamp: '2023-01-25T05:11:03.797Z',
  },
  {
    id: 10,
    first_name: 'Hannah',
    last_name: 'Clark',
    phone_number: '+1-151-501-7997',
    timestamp: '2023-01-28T13:46:28.885Z',
  },
  {
    id: 11,
    first_name: 'Ian',
    last_name: 'Lee',
    phone_number: '+1-434-521-5847',
    timestamp: '2023-01-31T17:51:15.994Z',
  },
  {
    id: 12,
    first_name: 'Jackie',
    last_name: 'Robinson',
    phone_number: '+1-360-649-6704',
    timestamp: '2023-02-03T00:38:30.929Z',
  },
  {
    id: 13,
    first_name: 'Kylie',
    last_name: 'Lewis',
    phone_number: '+1-830-949-5756',
    timestamp: '2023-02-06T16:36:42.839Z',
  },
  {
    id: 14,
    first_name: 'Liam',
    last_name: 'Walker',
    phone_number: '+1-957-554-4827',
    timestamp: '2023-02-09T20:42:13.920Z',
  },
  {
    id: 15,
    first_name: 'Mia',
    last_name: 'Martinez',
    phone_number: '+1-950-885-7827',
    timestamp: '2023-02-12T01:29:27.291Z',
  },
  {
    id: 16,
    first_name: 'Nathan',
    last_name: 'Young',
    phone_number: '+1-903-314-7285',
    timestamp: '2023-02-15T13:45:42.004Z',
  },
  {
    id: 17,
    first_name: 'Olivia',
    last_name: 'Anderson',
    phone_number: '+1-999-535-1509',
    timestamp: '2023-02-18T09:43:09.187Z',
  },
  {
    id: 18,
    first_name: 'Paul',
    last_name: 'Thomas',
    phone_number: '+1-127-708-8782',
    timestamp: '2023-02-21T09:27:21.414Z',
  },
  {
    id: 19,
    first_name: 'Quinn',
    last_name: 'Scott',
    phone_number: '+1-603-431-7804',
    timestamp: '2023-02-24T15:03:05.396Z',
  },
  {
    id: 20,
    first_name: 'Rachel',
    last_name: 'White',
    phone_number: '+1-593-267-7642',
    timestamp: '2023-02-27T09:37:06.408Z',
  },
  {
    id: 21,
    first_name: 'Sam',
    last_name: 'Taylor',
    phone_number: '+1-321-300-5617',
    timestamp: '2023-03-02T11:47:11.898Z',
  },
  {
    id: 22,
    first_name: 'Tom',
    last_name: 'Baker',
    phone_number: '+1-275-446-4165',
    timestamp: '2023-03-05T05:14:34.922Z',
  },
  {
    id: 23,
    first_name: 'Uma',
    last_name: 'Patel',
    phone_number: '+1-261-261-2771',
    timestamp: '2023-03-08T07:18:59.391Z',
  },
  {
    id: 24,
    first_name: 'Victor',
    last_name: 'Chen',
    phone_number: '+1-813-750-7118',
    timestamp: '2023-03-11T07:02:18.842Z',
  },
  {
    id: 25,
    first_name: 'Wendy',
    last_name: 'Moore',
    phone_number: '+1-450-297-8604',
    timestamp: '2023-03-14T12:08:49.290Z',
  },
  {
    id: 26,
    first_name: 'Xander',
    last_name: 'King',
    phone_number: '+1-489-634-6348',
    timestamp: '2023-03-17T10:19:16.583Z',
  },
  {
    id: 27,
    first_name: 'Yara',
    last_name: 'Nguyen',
    phone_number: '+1-744-515-9819',
    timestamp: '2023-03-20T08:27:31.287Z',
  },
  {
    id: 28,
    first_name: 'Zoe',
    last_name: 'Mitchell',
    phone_number: '+1-780-453-7739',
    timestamp: '2023-03-23T05:34:44.129Z',
  },
  {
    id: 29,
    first_name: 'Aaron',
    last_name: 'Rivera',
    phone_number: '+1-123-825-3306',
    timestamp: '2023-03-26T13:53:59.394Z',
  },
  {
    id: 30,
    first_name: 'Bella',
    last_name: 'Cooper',
    phone_number: '+1-587-483-4899',
    timestamp: '2023-03-29T08:25:17.367Z',
  },
  {
    id: 31,
    first_name: 'Carlos',
    last_name: 'Flores',
    phone_number: '+1-393-969-5169',
    timestamp: '2023-04-01T17:24:52.929Z',
  },
  {
    id: 32,
    first_name: 'Daisy',
    last_name: 'Reed',
    phone_number: '+1-192-751-9231',
    timestamp: '2023-04-04T05:23:18.020Z',
  },
  {
    id: 33,
    first_name: 'Elijah',
    last_name: 'Ward',
    phone_number: '+1-515-402-5175',
    timestamp: '2023-04-07T10:04:38.549Z',
  },
  {
    id: 34,
    first_name: 'Faith',
    last_name: 'Hughes',
    phone_number: '+1-736-199-4210',
    timestamp: '2023-04-10T00:04:54.212Z',
  },
  {
    id: 35,
    first_name: 'Gabriel',
    last_name: 'Price',
    phone_number: '+1-180-260-7172',
    timestamp: '2023-04-13T09:22:18.635Z',
  },
  {
    id: 36,
    first_name: 'Holly',
    last_name: 'Jenkins',
    phone_number: '+1-820-634-5255',
    timestamp: '2023-04-16T05:46:23.220Z',
  },
  {
    id: 37,
    first_name: 'Isaac',
    last_name: 'Butler',
    phone_number: '+1-504-423-4697',
    timestamp: '2023-04-19T08:40:56.513Z',
  },
  {
    id: 38,
    first_name: 'Jade',
    last_name: 'Ross',
    phone_number: '+1-725-376-7471',
    timestamp: '2023-04-22T15:54:28.179Z',
  },
  {
    id: 39,
    first_name: 'Kevin',
    last_name: 'Murphy',
    phone_number: '+1-116-759-9371',
    timestamp: '2023-04-25T18:04:33.853Z',
  },
  {
    id: 40,
    first_name: 'Laura',
    last_name: 'Peterson',
    phone_number: '+1-335-642-5236',
    timestamp: '2023-04-28T19:09:14.160Z',
  },
  {
    id: 41,
    first_name: 'Marcus',
    last_name: 'Bennett',
    phone_number: '+1-307-787-6404',
    timestamp: '2023-05-01T00:51:39.830Z',
  },
];

// Function to generate contact data
const generateContactData = (index) => {
  // const generateContactData = (index: number) => {
  const name = names[index % names.length];
  const hours = 4 + (index % 6);
  const minutes = (index % 60).toString().padStart(2, '0');
  const time = `${hours}:${minutes} ${hours >= 12 ? 'PM' : 'AM'}`;

  return {
    name,
    time,
  };
};

const ContactList = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllRooms());
  }, [dispatch]);

  const allRooms = useSelector((s) => s?.conversation);
  const [activeId, setActiveId] = useState(null);

  //

  return (
    <>
      <Box>
        <Box>
          {allRooms?.rooms && allRooms?.rooms.length > 0 ? (
            <>
              {allRooms?.rooms.map((item) => {
                // const filteredMessages = names.filter(
                //     (message) => message.roomId === item.id
                //   );
                return (
                  <Box>
                    <Box
                      key={item._id}
                      onClick={() => {
                        // console.log('Clicked Item Data:', item);
                        dispatch(
                          getThreads(item.prospectId._id, item.prospectId),
                        );
                        // handleBoxClick(item);
                        setActiveId(activeId === item._id ? null : item?._id);
                      }}
                      cursor="pointer"
                      bg={activeId === item.id ? '#F7F7F7' : 'transparent'} // Highlight active item
                      _hover={{ backgroundColor: '#F7F7F7' }}
                    >
                      <Flex py={4} justifyContent="space-between">
                        <Box>
                          <Flex>
                            <Wrap>
                              <WrapItem
                                alignItems="center"
                                justifyContent="center"
                                mx="auto"
                                ps={2}
                              >
                                <Avatar
                                  name={`${item?.prospectId.firstName || 'No'} ${
                                    item?.prospectId.lastName || 'Name'
                                  }`}
                                  color="white"
                                  size="md"
                                  // backgroundColor="#a71d75"
                                  src={item?.prospectId?.imageUrl}
                                />
                              </WrapItem>
                            </Wrap>
                            <Box ms={3}>
                              <Text
                                fontWeight={600}
                                fontSize={14}
                                color={
                                  activeId === item.id ? '#545454' : '#545454'
                                } // Change text color for active
                              >
                                {item?.prospectId.firstName || 'No'}{' '}
                                {item?.prospectId.lastName || 'Name'}
                              </Text>
                            </Box>
                          </Flex>
                        </Box>
                        <Box>
                          <Text
                            me={3}
                            fontSize={14}
                            fontWeight={400}
                            color={activeId === item.id ? '#545454' : '#545454'} // Change color for active contact
                          >
                            {item.direction == 'inbound'
                              ? item?.from?.phoneNumber
                              : item?.to?.phoneNumber || 'No Contact'}
                          </Text>
                          <Box
                            mx="auto"
                            justifyContent="center"
                            textAlign="center"
                          >
                            {/* {activeId !== item.id && names.length > 0 && (
                              <Badge
                                w="15px"
                                h="15px"
                                bg="#DD417F"
                                mt={1}
                                borderRadius={20}
                                p={1}
                                pt={0.5}
                                mx="auto"
                                justifyContent="center"
                                textAlign="center"
                                fontSize="10px"
                              ></Badge>
                            )} */}
                          </Box>
                        </Box>
                      </Flex>
                      <Divider
                        orientation="vertical"
                        borderBottom="solid 1px #d6d6d6"
                      />
                    </Box>
                  </Box>
                );
              })}
            </>
          ) : (
            <Box>
              <Text fontSize={15} fontWeight={400} color="#545454">
                No Contacts Available
              </Text>
            </Box>
          )}
        </Box>
      </Box>
    </>
  );
};
export default ContactList;
